import React, { memo } from 'react';
import Dialog from '../Dialog';
import DialogNotification from '../DialogAllowNotification';
import Confirm from "../Confirm";


const AllDialogs = (props) => {
	return (
		<>
			<Confirm {...props.confirm} handleClose={props.confirmClose}/>
			<Dialog {...props.readingNotification} closeReadingNotificationDialog={props.closeReadingNotificationDialog} setNoCache={props.setNoCache}/>
			<DialogNotification {...props.allowancebeingNotified} subscribeUserToPush={props.subscribeUserToPush} unSubscribeUserToPush={props.unSubscribeUserToPush}/>		
		</>
	)
}

export default memo(AllDialogs);